import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import { api, fmtDate } from "@/lib/api";

export const DraftReminderBar = ({ ev, onChanged }) => {
  const [open, setOpen] = useState(false);
  const last = ev.drafts.map((d) => d.reminded_at).filter(Boolean).sort().pop();
  const send = async () => {
    const { data } = await api.post(`/events/${ev.id}/draft-reminders`);
    const extra = [data.skipped_recent && `${data.skipped_recent} already reminded in the last 12 hours`, data.no_email && `${data.no_email} without an email address`].filter(Boolean).join(", ");
    (data.sent ? toast.success : toast.info)(`${data.sent} reminder email${data.sent === 1 ? "" : "s"} sent.${extra ? ` Skipped: ${extra}.` : ""}`);
    onChanged();
  };
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 py-3 border-b bg-amber-50/60" data-testid={`evreg-draft-reminder-bar-${ev.id}`}>
      <p className="text-xs text-gray-700">Email everyone with an unfinished draft, asking them to come back and complete their registration.{last && <span className="block text-gray-500" data-testid={`evreg-draft-last-reminder-${ev.id}`}>Last reminder sent {fmtDate(last)}</span>}</p>
      <button onClick={() => setOpen(true)} className="h-9 px-3 inline-flex items-center gap-2 rounded-md bg-[#E60000] hover:bg-[#CC0000] text-white text-sm font-semibold transition-colors shrink-0" data-testid={`evreg-draft-remind-${ev.id}`}><Mail className="w-4 h-4" />Send reminder emails</button>
      <ConfirmDialog open={open} onClose={() => setOpen(false)} onConfirm={send} testId="evreg-draft-remind"
        title={`Send reminders to ${ev.drafts.length} draft${ev.drafts.length === 1 ? "" : "s"}?`}
        description={`Each person with an unfinished registration for ${ev.title} gets an email with a link to complete it. Anyone reminded in the last 12 hours is skipped.`}
        confirmLabel="Send reminders" />
    </div>
  );
};
